module.exports = __webpack_public_path__ + "img/aeroland-clinic-image-03.115c56cf.png";